export default __webpack_public_path__ + "static/media/electroita.b200f76f.pdf";